import _defineProperty from "/app/node_modules/.pnpm/next@13.4.17_@babel+core@7.14.3_@opentelemetry+api@1.4.1_react-dom@18.2.0_react@18.2.0_sass@1.49.9/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { createSlice } from '@reduxjs/toolkit';
import { UiState } from 'constants/ui';
import { stateName } from './constants';
export const initialState = {
  payout: {
    amount: '',
    currency: '',
    progressDetails: [],
    uiState: UiState.Idle
  },
  payoutConfiguration: {
    amount: '',
    currency: '',
    note: null,
    uiState: UiState.Idle
  }
};

const getPayoutConfigurationRequest = draft => {
  draft.payoutConfiguration.uiState = UiState.Pending;
};

const getPayoutConfigurationSuccess = (draft, action) => {
  const {
    payoutConfiguration
  } = action.payload;
  draft.payoutConfiguration = _objectSpread(_objectSpread({}, payoutConfiguration), {}, {
    uiState: UiState.Success
  });
};

const getPayoutConfigurationFailure = draft => {
  draft.payoutConfiguration.uiState = UiState.Failure;
};

const getPayoutRequest = draft => {
  draft.payout.uiState = UiState.Pending;
};

const getPayoutFailure = draft => {
  draft.payout.uiState = UiState.Failure;
};

const getPayoutSuccess = (draft, action) => {
  const {
    payout
  } = action.payload;
  draft.payout = _objectSpread(_objectSpread({}, payout), {}, {
    uiState: UiState.Success
  });
};

const payoutSlice = createSlice({
  name: stateName,
  initialState,
  reducers: {
    getPayoutConfigurationRequest,
    getPayoutConfigurationSuccess,
    getPayoutConfigurationFailure,
    getPayoutRequest,
    getPayoutSuccess,
    getPayoutFailure
  }
});
export const {
  actions
} = payoutSlice;
export const plug = {
  [stateName]: payoutSlice.reducer
};
export default payoutSlice.reducer;